import React from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "../i18n/LocaleContext";

export type ActivityItem = {
  id: string;
  title: string;
  detail: string;
  tone: "neutral" | "good" | "warning" | "critical";
  timestamp: string;
  action?: "answer" | "open";
};

interface ActivityPanelProps {
  activity: ActivityItem[];
  onClear: () => void;
  onNotificationClick: (item: ActivityItem) => void;
  className?: string;
}

const ActivityPanel: React.FC<ActivityPanelProps> = ({ activity, onClear, onNotificationClick, className }) => {
  const { t } = useTranslation();
  return (
    <article className={`status-card activity-card${className ? ` ${className}` : ""}`}>
      <div className="card-header">
        <h2>{t("activityPanel.title")}</h2>
        <Button variant="outlined" disabled={activity.length === 0} onClick={onClear} aria-label={t("activityPanel.clearAria")}>
          <DeleteIcon />
        </Button>
      </div>
      <div className="activity-list">
        {activity.map((item) => (
          <button key={item.id} className={`activity-item ${item.tone}`} onClick={() => onNotificationClick(item)}>
            <span>{item.timestamp}</span>
            <strong>{item.title}</strong>
            <p>{item.detail}</p>
          </button>
        ))}
        {activity.length === 0 && (
          <p className="activity-empty-state">{t("activityPanel.empty")}</p>
        )}
      </div>
    </article>
  );
};

export default ActivityPanel;
